import React from 'react';

export default function ProposeToReloadBar (props) {
  return (
    <div className="alert alert-warning py-2">
      お使いのLOGISPのバージョンは最新ではありません。
      <a href="#" onClick={_ => window.location.reload()}>
        リロード
      </a>
      してください。
    </div>
  );
}
